import { render, staticRenderFns } from "./AlertLayout.vue?vue&type=template&id=bd7cf6a2&scoped=true&"
import script from "./AlertLayout.vue?vue&type=script&lang=js&"
export * from "./AlertLayout.vue?vue&type=script&lang=js&"
import style0 from "./AlertLayout.vue?vue&type=style&index=0&id=bd7cf6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7cf6a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VRow})
